<template>
  <div class="footer" >
      <div style="display: flex; gap: 1em;  margin:auto;">
       
         <CustomButton v-if="homeBtn" @click="goHome()" :buttonTitle="'HOME'" :buttonIcon="'back'" :buttonColour="'grey'"></CustomButton>
        <CustomButton v-if="backBtn" @click="goBack()" :buttonTitle="'GO BACK'" :buttonIcon="'back'" :buttonColour="'grey'"></CustomButton>
         <CustomButton v-if="detailBtn" @click="doFInd()" :buttonTitle="'DETAILED SEARCH'" :buttonIcon="'back'" :buttonColour="'grey'"></CustomButton>
        <CustomButton v-if="cantFindBtn" @click="cantFInd()" :buttonTitle="'I CAN’T FIND MY CONVICT'" :buttonIcon="'search'" :buttonColour="'grey'"></CustomButton>
        <CustomButton v-if="nextBtn" @click="next()" :buttonTitle="'NEXT'" :buttonIcon="'search'" :buttonColour="'grey'"></CustomButton>
        <CustomButton v-if="rndBtn" @click="nextRnd()" :buttonTitle="'NEXT'" :buttonIcon="'search'" :buttonColour="'grey'"></CustomButton>
      </div>
   </div>
</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
export default {
  name: "Footer",
  props: {
    homeBtn: { type: Boolean ,default:true},
    backPath: { type: String ,default:"/"},
    cantFindBtn: { type: Boolean ,default:true},
    backBtn: { type: Boolean ,default:true},
    nextBtn: { type: Boolean ,default:false},
    rndBtn: { type: Boolean ,default:false},
    detailBtn: { type: Boolean ,default:true},
  },
   components: {
    CustomButton,
  },
  mounted(){
    
  },
  computed: {
    
  },
  methods: {
    doFInd(){
      this.$router.push("find")
    },
    goHome(){
      this.$router.push("/")
    },
    cantFInd(){
      this.$emit("cantFind")
      
    },
    next(){
      this.$emit("next")
      
    },
    nextRnd(){
      this.$emit("nextRnd")
      
    },
    goBack(){

      
      if(this.backPath){
         this.$router.push(this.backPath)
      }else{
        this.$emit("goBack")
      }
     
    },
    
  },
};
</script>

<style scoped>


h2, h3 {
  margin: 0;
  margin-top: 0.35em;
}
p {
  margin: 0;
  margin-top: clamp(0.75em, 2.75vw, 0.85em);
  margin-right: 0.25em;
}
.footer {
  width:100vw; 
  display:flex;
   position:fixed; 
   bottom:.2em; 
   left:0px;
    z-index:1;
  
}
  @media (max-width: 500px) {
.footer {
  width:100vw; 
  display:flex;
   position:fixed; 
   bottom:.2em; 
   left:0px;
   z-index:1;
  
}
  }
</style>